import { CustomTooltip } from '@AMIEWEB/Common/Tooltips/CustomTooltip';
import { Box, Paper } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  tileContainer: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: 3,
    border: `1px solid ${theme.palette.system.fadedGray}`,
    Height: '30px',
    marginBottom: '6px',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 45,
    borderRadius: '4px 0px 0px 4px',
    color: theme.palette.system.black,
    fontSize: 14,
    padding: '5px 12px',
    lineHeight: '14px',
    whiteSpace: 'nowrap',
  },
  primary: {
    background: theme.palette.system.violet,
    color: `${theme.palette.system.white} !important`,
    fontSize: 14,
    padding: '12px 15px',
    borderRadius: '3px 0px 0px 3px',
  },
  secondary: {
    background: theme.palette.system.lightGreyStatus,
    color: `${theme.palette.system.violet} !important`,
    fontSize: 14,
    padding: '12px 15px',
    borderRadius: '3px 0px 0px 3px',
    fontWeight: 'bold',
  },
}));

export const SimpleTile = props => {
  const { classes } = useStyles();

  return (
    <Paper elevation={0} className={classes.tileContainer}>
      <CustomTooltip tooltipContent={props?.tooltipContent ?? props?.data}>
        <div className={props?.type === 'secondary' ? classes.secondary : classes.primary}>{props.data}</div>
      </CustomTooltip>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
      <div className={classes.title}>{props.title}</div>
      <div className={classes.title}>{props.endAdornment}</div>
      </Box>
    </Paper>
  );
};
